import { Component, Input, OnInit } from '@angular/core';
import { DataService } from '../../../data.service';

@Component({
  selector: 'app-parent-portal-panel',
  templateUrl: './parent-portal-panel.component.html',
  styleUrls: ['./parent-portal-panel.component.scss']
})
export class ParentPortalPanelComponent implements OnInit {

  @Input() patientId: string;

  loading = false;
  saving = false;
  linked = false;
  parentEmail = '';
  parentName = '';
  linkedAt = '';
  emailInput = '';

  constructor(private dataService: DataService) { }

  ngOnInit() {
    this.load();
  }

  load() {
    if (!this.patientId) { return; }
    this.loading = true;
    this.dataService.getOtgoalsParentLinkStatus(this.patientId).subscribe((res: any) => {
      this.loading = false;
      if (res.status == 0) {
        this.linked = res.data.linked;
        this.parentEmail = res.data.parent_email || '';
        this.parentName = res.data.parent_name || '';
        this.linkedAt = res.data.linked_at || '';
      }
    });
  }

  linkParent() {
    if (!this.emailInput) { return; }
    this.saving = true;
    this.dataService.postOtgoalsLinkParent({ patient_id: this.patientId, parent_email: this.emailInput }).subscribe((res: any) => {
      this.saving = false;
      if (res.status == 0) {
        this.emailInput = '';
        this.load();
      } else {
        alert(res.msg);
      }
    });
  }

  unlinkParent() {
    if (!confirm('Unlink this parent account from the patient?')) { return; }
    this.saving = true;
    this.dataService.postOtgoalsUnlinkParent({ patient_id: this.patientId }).subscribe((res: any) => {
      this.saving = false;
      if (res.status == 0) {
        this.load();
      } else {
        alert(res.msg);
      }
    });
  }

}
